import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xx7exzjwu: FaireProductEntity = {
  token: "p_5xx7exzjwu",
  type: "product",
  name: "Crystal Rose - Carved Stone -",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/d60dd160f5d63a8c73cc495d25898a2c38af12dc30f9d721b089a798d28b1cad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f2e8dbbd768737e21d992628b6417f9a767e451c0044ab3351cec5c06e698c4.jpeg",
    "https://cdn.faire.com/fastly/94afe1defe91421205f994a469386e2ba195a0a6f45503f9c857e65b8d921bb7.jpeg",
    "https://cdn.faire.com/fastly/8357d9a581cde30d2d06b738b3f9a1927e5e31b8efb71722756058f61ea091d7.jpeg",
    "https://cdn.faire.com/fastly/f678b6c5d02e3970bb4ab6930c7bcfde650d8395d800bb56d5b38e8a96eb617e.jpeg",
    "https://cdn.faire.com/fastly/dc169d5e6884166b2e57b0c391418a9dd80f0b2cfdc4e02339a38b0599792618.jpeg",
    "https://cdn.faire.com/fastly/cf86230238f97037aefef965134aafb00cda784b7c2c33cdeb28182f2af1c842.jpeg",
    "https://cdn.faire.com/fastly/0c04b2e34b27ad09f717542e5e7bf59472d34fa26440ab3a9a1f2ed566b3461c.jpeg",
    "https://cdn.faire.com/fastly/1db33f7258ad7a4b71f2b2759a60f69a82d140f1f304953d3cba712c68b6f844.jpeg",
    "https://cdn.faire.com/fastly/f97bb2ac9920fb586fc641819717c14a432fbafb8d65d2d111ad6cabffa2edbd.jpeg",
    "https://cdn.faire.com/fastly/4408e68e10b915cd67cae2eb92a83c59d87fd72a623445e0a45a8fdc5a4e2b59.jpeg",
    "https://cdn.faire.com/fastly/bd5e9acc20cf248f0829cbcc6252d1b15da835f93af8006b5d1ab1a3c982f677.jpeg",
    "https://cdn.faire.com/fastly/eded7084385699ad8788c9cac71b48df619e3560922d073818139124fa01b641.jpeg",
    "https://cdn.faire.com/fastly/6e92edf0a94be89be2e882cf4c7d4271862b2179e4689393815445efad5b9649.jpeg",
    "https://cdn.faire.com/fastly/679a3aef7466743245146bf958642e7e8c1ec4a9468ab99343be6ba681c6c9d5.jpeg",
    "https://cdn.faire.com/fastly/8b115397604e3b21ac3bc96aba401ed392e184848fe3c28aa6fdb37de3114079.jpeg",
    "https://cdn.faire.com/fastly/be104a88fbc4eb8b3c1baa0c580eec7633adbd25886eb5746e8c26072f358e1c.jpeg",
    "https://cdn.faire.com/fastly/39eff24c7861033d239e2c5ee8e2185af123cb5daf3fb71931b51de165cb4305.jpeg",
    "https://cdn.faire.com/fastly/bf99f961a6c64cf25974d20aa6d99c41285f7817e80f4fa4e8aa6bc49ddb1b8a.jpeg",
    "https://cdn.faire.com/fastly/a76e457e3306718d43dcdbbe8be0233e97632f17acb3861b9bee1fd17e63216c.jpeg",
  ],
  priceDollars: 16.63,
  description:
    'This listing is for ONE (1) Crystal Rose Carved Stone (LWS-S6)\n\nBeautiful carved crystal roses on a metal stem! Each is hand cut, shaped and polished into the roses you see pictured. Makes a perfect gift for that special someone.\n\nSTOCK PHOTO. These stones vary slightly in sizes & characteristics. The rose bud on top needs to be screwed on to the metal stem once received. Should the stone comes unglued you can give it a quick fix with any jewelry glue (we like E600!)\n\nMeasure approx.: Rose: 1.5" t x 1.5" w 1.375" t \nStem: 7.75" t 3.125" w\n\nChoose Finish:\nGold/Silver\n\nChoose your Stone! \nGreen Aventurine - Abundance\nFluorite - Positivity\nMoss Agate - Tranquility\nLabradorite - Protects from Negativity\nStrawberry Quartz - Self-love\nRose Quartz - Unconditional Love\nHematoid Quartz - Grounding\nLepidolite - Protection\nCalcite (pale yellow to pale orange) - Positivity \nBlack Obsidian - Protection\nYooperlite - Clarity\nChevron Amethyst - Tranquility\nSodalite - Calm & Truth',
  tags: [],
  msrpDollars: 33.26,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:46.116Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
